import { apiRequest } from './api.js';
import API_CONFIG from './api.js';

// User related API calls
export const userService = {
  // Check if current user has portal access
  checkPortalAccess: async (token) => {
    const url = `${API_CONFIG.BACKEND_URL}/admin/check-portal-access`;
    
    return await apiRequest(url, {
      method: 'GET',
      token
    });
  },

  // Get current user profile
  getCurrentUser: async (token) => {
    const url = `${API_CONFIG.BACKEND_URL}/user/profile`;
    
    return await apiRequest(url, {
      method: 'GET',
      token
    });
  }
};

export default userService;
